type OrgRole = ClerkAuthorization['role'];

/**
 * Developer credits never mix with app (subscription and add-on) credits: each charge, hold and
 * purchase is on exactly one pool.
 */
export type CreditPool = 'app' | 'developer';

/** Free developer credits for the first sign-up from each company (one claim per email domain). */
export const DEVELOPER_SIGNUP_CREDITS = 100;

/** What the sign-up credits are marketed as, in USD: 100 credits at USD 0.25 each. */
export const DEVELOPER_SIGNUP_CREDIT_VALUE_USD = 25;

/**
 * Developer credits each developer sign-up org that got the sign-up credits gets on the 1st of every
 * month (Sydney time), use it or lose it. Granted by app.grant_developer_monthly_credits, which fixes
 * the same number; change both.
 */
export const DEVELOPER_MONTHLY_CREDITS = 40;

/** What the monthly credits are marketed as, in USD, at the sign-up credits' rate: 40 × USD 0.25. */
export const DEVELOPER_MONTHLY_CREDIT_VALUE_USD =
  (DEVELOPER_MONTHLY_CREDITS * DEVELOPER_SIGNUP_CREDIT_VALUE_USD) / DEVELOPER_SIGNUP_CREDITS;

/** Prefix of the API keys the developer portal creates (`fbl_dev_…`); Unkey joins it with `_`. */
export const DEVELOPER_KEY_PREFIX = 'fbl_dev';

/** Clerk sends the role with or without the `org:` prefix depending on instance and token version. */
export const isDeveloperRole = (role: string | null | undefined): role is OrgRole =>
  role === 'org:developer' || role === 'developer';

/**
 * Whether a member only gets the developer portal: anyone holding the developer role, and everyone in
 * an org created through the developer sign-up.
 */
export const isDeveloperMember = ({ role, orgType }: { role?: string | null; orgType?: string | null }) =>
  isDeveloperRole(role) || orgType === 'developer';
